<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            fill-height
            fluid
            grid-list-xl
    >
        <v-layout wrap>
<!--            <template v-slot:activator="{ on }">-->
            <v-btn
                    color="red lighten-2"
                    dark
                    @click="testcmd()"
            >
                testcmd
            </v-btn>
            <v-btn
                    color="red lighten-2"
                    dark
                    v-on:click="dialog = true"
            >
                Click Me123asdasd
            </v-btn>
<!--            </template>-->
            <v-dialog
                    v-model="dialog"
                    width="500"
            >
<!--                <template v-slot:activator="{ on }">-->
<!--                    <v-btn-->
<!--                            color="red lighten-2"-->
<!--                            dark-->
<!--                            v-on="on"-->
<!--                    >-->
<!--                        Click Me345345-->
<!--                    </v-btn>-->
<!--                </template>-->

                <v-card>
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        Privacy Policy
                    </v-card-title>

                    <v-card-text>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                        laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                        voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                        non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                        >
                            I accept
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <!--      <amplify-sign-in></amplify-sign-in>-->
            <!--      <amplify-sign-up v-bind:signUpConfig=""></amplify-sign-up>-->
            <!--      <StatsCard-->
            <!--              color="green"-->
            <!--              icon="mdi-store"-->
            <!--              title="Revenue"-->
            <!--              value="$34,245"-->
            <!--              sub-icon="mdi-calendar"-->
            <!--              sub-text="Last 24 Hours"></StatsCard>-->

            <UserButton></UserButton>
            <Test></Test>
            <material-stats-card
                    color="green"
                    icon="mdi-store"
                    title="Revenue"
                    value="$34,245"
                    sub-icon="mdi-calendar"
                    sub-text="Last 24 Hours"></material-stats-card>
            <!--      <amplify-authenticator :auth-config="authConfig"/>-->
            <!--      <amplify-sign-out/>-->
            <!--      <amplify-authenticator :auth-config="authConfig"></amplify-authenticator>-->
            <br>
            <v-flex
                    md12
                    sm12
                    lg4
            >
                <v-btn
                        color="success"
                        @click="testi()"
                >testi
                </v-btn>
                <v-btn
                        color="success"
                        @click="testinsert()"
                >testinsert
                </v-btn>
                <!--        <button v-text="asd" value="asd">asd</button>-->
                <v-btn
                        color="success"
                        @click="test()"
                >select222
                </v-btn>
                <v-btn
                        color="success"
                        @click="test()"
                >select
                </v-btn>
                <v-btn
                        color="success"
                        @click="test()"
                >select
                </v-btn>
                <v-btn
                        color="success"
                        @click="test()"
                >select
                </v-btn>
                <v-btn
                        color="success"
                        @click="test()"
                >select
                </v-btn>
                <v-btn
                        color="success"
                        @click="test()"
                >select
                </v-btn>
                <v-btn
                        color="success"
                        @click="testi()"
                >insert
                </v-btn>
                <v-btn
                        color="success"
                        @click="signin()"
                >signin
                </v-btn>
                <v-btn
                        color="success"
                        @click="signout()"
                >signout
                </v-btn>
                <material-chart-card
                        :data="dailySalesChart.data"
                        :options="dailySalesChart.options"
                        color="info"
                        type="Line"
                >
                    <h4
                            class="title font-weight-light"
                            @click="test()">
                        Daily Sales
                    </h4>
                    <p class="category d-inline-flex font-weight-light">
                        <v-icon
                                color="green"
                                small
                        >
                            mdi-arrow-up
                        </v-icon>
                        <span class="green--text">55%</span>&nbsp;
                        increase in today's sales
                    </p>

                    <template slot="actions">
                        <v-icon
                                class="mr-2"
                                small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span class="caption grey--text font-weight-light">updated 4 minutes asdqweqwego</span>
                    </template>
                </material-chart-card>
            </v-flex>
            <v-flex
                    md12
                    sm12
                    lg4
            >
                <material-chart-card
                        :data="emailsSubscriptionChart.data"
                        :options="emailsSubscriptionChart.options"
                        :responsive-options="emailsSubscriptionChart.responsiveOptions"
                        color="red"
                        type="Bar"
                >
                    <h4 class="title font-weight-light">Email Subscription</h4>
                    <p class="category d-inline-flex font-weight-light">Last Campaign Performance</p>

                    <template slot="actions">
                        <v-icon
                                class="mr-2"
                                small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span class="caption grey--text font-weight-light">updated 10 minutes ago</span>
                    </template>
                </material-chart-card>
            </v-flex>
            <v-flex
                    md12
                    sm12
                    lg4
            >
                <material-chart-card
                        :data="dataCompletedTasksChart.data"
                        :options="dataCompletedTasksChart.options"
                        color="green"
                        type="Line"
                >
                    <h3 class="title font-weight-light">Completed Tasks</h3>
                    <p class="category d-inline-flex font-weight-light">Last Last Campaign Performance</p>

                    <template slot="actions">
                        <v-icon
                                class="mr-2"
                                small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span class="caption grey--text font-weight-light">campaign sent 26 minutes ago</span>
                    </template>
                </material-chart-card>
            </v-flex>
            <v-flex
                    sm6
                    xs12
                    md6
                    lg3
            >
                <material-stats-card
                        color="green"
                        icon="mdi-store"
                        title="Revenue"
                        value="$34,245"
                        sub-icon="mdi-calendar"
                        sub-text="Last 24 Hours"
                />
            </v-flex>
            <v-flex
                    sm6
                    xs12
                    md6
                    lg3
            >
                <material-stats-card
                        color="orange"
                        icon="mdi-content-copy"
                        title="Used Space"
                        value="49/50"
                        small-value="GB"
                        sub-icon="mdi-alert"
                        sub-icon-color="error"
                        sub-text="Get More Space..."
                        sub-text-color="text-primary"
                />
            </v-flex>
            <v-flex
                    sm6
                    xs12
                    md6
                    lg3
            >
                <material-stats-card
                        color="red"
                        icon="mdi-information-outline"
                        title="Fixed Issues"
                        value="75"
                        sub-icon="mdi-tag"
                        sub-text="Tracked from Github"
                />
            </v-flex>
            <v-flex
                    sm6
                    xs12
                    md6
                    lg3
            >
                <material-stats-card
                        color="info"
                        icon="mdi-twitter"
                        title="Followers"
                        value="+245"
                        sub-icon="mdi-update"
                        sub-text="Just Updated"
                />
            </v-flex>
            <v-flex
                    md12
                    lg6
            >
                <material-card
                        color="orange"
                        title="Employee Stats"
                        text="New employees on 15th September, 2016"
                >
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            hide-actions
                    >
                        <template
                                slot="headerCell"
                                slot-scope="{ header }"
                        >
              <span
                      class="font-weight-light text-warning text--darken-3"
                      v-text="header.text"
              />
                        </template>
                        <template
                                slot="items"
                                slot-scope="{ index, item }"
                        >
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.name }}</td>
                            <td class="text-xs-right">{{ item.salary }}</td>
                            <td class="text-xs-right">{{ item.country }}</td>
                            <td class="text-xs-right">{{ item.city }}</td>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>
            <v-flex
                    md12
                    lg6
            >
                <material-card
                        class="card-tabs"
                        color="green">
                    <v-flex
                            slot="header"
                    >
                        <v-tabs
                                v-model="tabs"
                                color="transparent"
                                slider-color="white"
                        >
              <span
                      class="subheading font-weight-light mr-3"
                      style="align-self: center"
              >Tasks:</span>
                            <v-tab class="mr-3">
                                <v-icon class="mr-2">mdi-bug</v-icon>
                                Bugs
                            </v-tab>
                            <v-tab class="mr-3">
                                <v-icon class="mr-2">mdi-code-tags</v-icon>
                                Website
                            </v-tab>
                            <v-tab>
                                <v-icon class="mr-2">mdi-cloud</v-icon>
                                Server
                            </v-tab>
                        </v-tabs>
                    </v-flex>

                    <v-tabs-items v-model="tabs">
                        <v-tab-item
                                v-for="n in 3"
                                :key="n"
                        >
                            <v-list three-line>
                                <v-list-tile @click="complete(0)">
                                    <v-list-tile-action>
                                        <v-checkbox
                                                :value="list[0]"
                                                color="green"
                                        />
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Sign contract for "What are conference organized afraid of?"
                                    </v-list-tile-title>
                                    <div class="d-flex">
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn--simple"
                                                    color="success"
                                                    icon
                                            >
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn--simple"
                                                    color="danger"
                                                    icon
                                            >
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                            <span>Close</span>
                                        </v-tooltip>

                                    </div>
                                </v-list-tile>
                                <v-divider/>
                                <v-list-tile @click="complete(1)">
                                    <v-list-tile-action>
                                        <v-checkbox
                                                :value="list[1]"
                                                color="success"
                                        />
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Lines From Great Russian Literature? Or E-mails From My Boss?
                                    </v-list-tile-title>
                                    <div class="d-flex">
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn--simple"
                                                    color="success"
                                                    icon
                                            >
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>

                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn--simple"
                                                    color="danger"
                                                    icon>
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                            <span>Close</span>
                                        </v-tooltip>
                                    </div>
                                </v-list-tile>
                                <v-divider/>
                                <v-list-tile @click="complete(2)">
                                    <v-list-tile-action>
                                        <v-checkbox
                                                :value="list[2]"
                                                color="success"
                                        />
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Flooded: One year later, assessing what was lost and what was found when a
                                        ravaging rain swept through metro Detroit
                                    </v-list-tile-title>
                                    <div class="d-flex">
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn--simple"
                                                    color="success"
                                                    icon
                                            >
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn--simple"
                                                    color="danger"
                                                    icon
                                            >
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                            <span>Close</span>
                                        </v-tooltip>

                                    </div>
                                </v-list-tile>
                            </v-list>
                        </v-tab-item>
                    </v-tabs-items>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

  import {Auth} from 'aws-amplify'
  import StatsCard from '../components/material/StatsCard'
  import Test from '../components/core/Test'
  import UserButton from '../components/core/UserButton'
  import tool_app from '../utils/tool_app'

  export default {
    components: {UserButton, Test, StatsCard,},
    data () {
      return {
        dialog: false,
        authConfig: {
          signUpConfig: {
            header: 'Sign up for an account',
            // hiddenDefaults: ['phone_number', 'username'],
            hiddenDefaults: ['phone_number', 'email'],
            signUpFields: [
              // {
              //   label: 'Email',
              //   key: 'email',
              //   type: 'string',
              //   required: true,
              //   displayOrder: 0
              // },
              {
                label: 'Username',
                key: 'username',
                type: 'string',
                required: true,
                displayOrder: 0
              },
              {
                label: 'Password',
                key: 'password',
                type: 'password',
                required: true,
                displayOrder: 1
              },
            ]
          },
          confirmSignUpConfig: {
            // header: 'Please enter the code sent to your email'
          },
        },
        dailySalesChart: {
          data: {
            labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            series: [
              [12, 17, 7, 17, 23, 18, 38]
            ]
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0
            }),
            low: 0,
            high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        },
        dataCompletedTasksChart: {
          data: {
            labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
            series: [
              [230, 750, 450, 300, 280, 240, 200, 190]
            ]
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0
            }),
            low: 0,
            high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        },
        emailsSubscriptionChart: {
          data: {
            labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

            ]
          },
          options: {
            axisX: {
              showGrid: false
            },
            low: 0,
            high: 1000,
            chartPadding: {
              top: 0,
              right: 5,
              bottom: 0,
              left: 0
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        headers: [
          {
            sortable: false,
            text: 'ID',
            value: 'id'
          },
          {
            sortable: false,
            text: 'Name',
            value: 'name'
          },
          {
            sortable: false,
            text: 'Salary',
            value: 'salary',
            align: 'right'
          },
          {
            sortable: false,
            text: 'Country',
            value: 'country',
            align: 'right'
          },
          {
            sortable: false,
            text: 'City',
            value: 'city',
            align: 'right'
          }
        ],
        items: [
          {
            name: 'Dakota Rice',
            country: 'Niger',
            city: 'Oud-Tunrhout',
            salary: '$35,738'
          },
          {
            name: 'Minerva Hooper',
            country: 'Curaçao',
            city: 'Sinaai-Waas',
            salary: '$23,738'
          }, {
            name: 'Sage Rodriguez',
            country: 'Netherlands',
            city: 'Overland Park',
            salary: '$56,142'
          }, {
            name: 'Philip Chanley',
            country: 'Korea, South',
            city: 'Gloucester',
            salary: '$38,735'
          }, {
            name: 'Doris Greene',
            country: 'Malawi',
            city: 'Feldkirchen in Kārnten',
            salary: '$63,542'
          }
        ],
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      testcmd () {
        tool_app.lg('testcmd ');

        tool_app.api('SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50').then(function (response) {
          // resolve()의 결과 값이 여기로 전달됨
          console.log('tableData: ', response); // $.get()의 reponse 값이 tableData에 전달됨
          response.data.results.forEach(function (element) {
            tool_app.lg('el:', element);
          })
        });
      },
      test () {
        console.log('test')
        // // CORS
        // $.support.cors = true;
        // // https://github.com/MoonScript/jQuery-ajaxTransport-XDomainRequest
        // // if (window.XDomainRequest ) {
        // //   tool_app.log('send XDomainRequest 1 '+payload);
        //   $.ajax({
        //     url: urlString,
        //     data: payload,
        //     contentType: 'text/plain; charset=euc-kr',
        //     // contentType: 'text/plain; charset=UTF-8',
        //     // contentType: "application/x-www-form-urlencoded; charset=euc-kr",
        //     type: 'POST',
        //     dataType: 'json',
        //     // beforeSend: function(jqXHR) {
        //     //     jqXHR.overrideMimeType('text/plain; charset=euc-kr');
        //     //     // jqXHR.overrideMimeType('text/plain; charset=UTF-8');
        //     //     // jqXHR.overrideMimeType('application/x-www-form-urlencoded; charset=euc-kr');
        //     // },
        //   }).done(function(data) {
        //     // tool_app.log('send XDomainRequest 2 '+JSON.stringify(data));
        //     mainapi.log('invokeAPI LB 1 success '+data);
        //     // mainapi.log('invokeAPI LB 1 success '+JSON.stringify(data));
        //     api.from(data);
        //     // mainapi.log('invokeAPI LB 2 success LogResult:'+data.rLogResult);
        //     handler(data, null);
        //     // console.log(data.name.last);
        //   });

        // }
        // else {
        //   // tool_app.log('send jquery post 1 '+payload);
        //   $.post(urlString,
        //           payload,
        //           // function( data ) {
        //           //   // $( ".result" ).html( data );
        //           //   // var p = JSON.parse(data);
        //           //   // api.from(p);
        //           //   mainapi.log('invokeAPI LB 1 success '+data);
        //           //   mainapi.log('invokeAPI LB 1 success '+JSON.stringify(data, null, 2));
        //           //   api.from(data);
        //           //   mainapi.log('invokeAPI LB 2 success \n'+data.rLogResult);
        //           //   handler(data, null);
        //           // })
        //           // .fail(function( jqXHR, textStatus, errorThrown) {
        //           //   mainapi.log('invokeAPI LB fail textStatus:'+textStatus);
        //           //   mainapi.log('invokeAPI LB fail errorThrown:'+errorThrown);
        //           //   mainapi.log('invokeAPI LB fail jqXHR:'+JSON.stringify(jqXHR, null, 2));
        //           //   // mainapi.log('invokeAPI LB fail LogResult:'+data.rLogResult);
        //           //   // // set a new cookie
        //           //   // var expiry = new Date();
        //           //   // expiry.setTime(expiry.getTime()+(5*60*1000)); // 5 minutes
        //           //   //
        //           //   // mainapi.$cookies.put(CookieKey_LBFailed, 'true '+expiry.format('yyyy-MM-dd hh:mm:ss'), {
        //           //   //     expires: expiry,
        //           //   // });
        //           //   handler(null, new Error());
        //           // })
        //           // .always(function() {
        //           //   mainapi.log('invokeAPI LB always');
        //           //   // mainapi.log('invokeAPI LB always '+mainapi.$cookies.get(CookieKey_LBFailed));
        //           //   // if(isCookieKey_LBFailed()) {
        //           //   //     invokeAPIToLambda(api, payload, handler);
        //           //   // }
        //           // });
        //
        //           function( data ) {
        //           })
        //           .always(function(data, textStatus, errorThrown) {
        //             // var err = false;
        //             // mainapi.log('invokeAPI LB 1 data:'+JSON.stringify(data, null, 2)+'\n textStatus:'+textStatus+'\n errorThrown:'+JSON.stringify(errorThrown, null, 2));
        //             // if(textStatus === 'success') {
        //             //   api.from(data);
        //             //   // mainapi.log('invokeAPI LB 2 api.rStatusCode:'+api.rStatusCode);
        //             //   if(api.rStatusCode !== mainapi.StatusCode_OK) {
        //             //     err = true;
        //             //     if(tool_app.isStringBlank(api.rMessage)) {
        //             //       api.rMessage = '서버와의 통신에 실패했습니다.';
        //             //     }
        //             //   }
        //             // }
        //             // else {
        //             //   err = true;
        //             //   if(tool_app.isStringBlank(api.rMessage)) {
        //             //     api.rMessage = '서버와의 통신에 실패했습니다.';
        //             //   }
        //             // }
        //             // // if(err === false) {
        //             //   handler(data, err);
        //             // // }
        //             var err = null;
        //             mainapi.log('invokeAPI LB 1 data:'+JSON.stringify(data, null, 2)+'\n textStatus:'+textStatus+'\n errorThrown:'+JSON.stringify(errorThrown, null, 2));
        //             if(textStatus === 'success') {
        //               api.from(data);
        //               mainapi.log('invokeAPI LB 2 '+api.rStatusCode);
        //               if(api.rStatusCode !== mainapi.StatusCode_OK) {
        //                 err = '서버와의 통신에 실패했습니다.';
        //                 if(tool_app.isStringBlank(api.rMessage)) {
        //                   api.rMessage = err;
        //                 }
        //               }
        //             }
        //             else {
        //               err = '서버와의 통신에 실패했습니다.';
        //               if(tool_app.isStringBlank(api.rMessage)) {
        //                 api.rMessage = err;
        //               }
        //             }
        //             handler(data, err);
        //           });

        Auth.currentSession()
          .then(data => {
            console.log(data)

            this.$http({
              method: 'post', // you can set what request you want to be
                // url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
                url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/center1-reservation-20190826',
              data: {
                'c': 'console.log("asd");',
                'query': 'SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50',
                'params': [Math.random() * 10000],
                'greeter': 'asd',
              },
              headers: {
                'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
                'Content-Type': 'application/json',
                'Authorization': data.idToken.jwtToken,
              }
            })
              .then(function (response) {
                // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
                console.log('response:', response)
                response.data.results.forEach(function (element) {
                  console.log(element)
                })
              })
          })
          .catch(err => console.log(err))

        // this.$http({
        //   method: 'post', //you can set what request you want to be
        //   url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
        //   data: {
        //     "c": "console.log(\"asd\");",
        //     "query": "SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50",
        //     "greeter": "asd",
        //     "params": []
        //   },
        //   headers: {
        //     "x-api-key": "FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM",
        //     "Content-Type": "application/json",
        //   }
        // })
        //         .then(function (response) {
        //           // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
        //           console.log('response:',response);
        //           response.data.results.forEach(function (element) {
        //             console.log(element);
        //           });
        //         });

        // this.$http.post('https://example.com/postSomething', {
        //           email: 'qwe', //varEmail is a variable which holds the email
        //           password: 'asd'
        //         },
        //         {
        //           headers: {
        //             Authorization: 'Bearer '
        //           }
        //         })

        // this.$http.post('https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618', {
        //   "c": "console.log(\"asd\");",
        //   "query": "SELECT * FROM `table_name` LIMIT 50",
        //   "greeter": "asd",
        //   "params": []
        // }, {
        //   headers: {
        //     "x-api-key": "FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM",
        //     "Content-Type": "application/json",
        //   }
        // })
        //         .then((result) => {
        //           console.log(result)
        //           this.posts = result.data
        //         })

        // axios.post('https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618', {
        //   firstName: 'Fred',
        //   lastName: 'Flintstone'
        // })
        //         .then(function (response) {
        //           console.log(response);
        //         })
        //         .catch(function (error) {
        //           console.log(error);
        //         });
      },
      testi () {
        // console.log('testi')
        // console.log('testi')
        // console.log('testi')
        console.log('testi')
        tool_app.api('INSERT INTO `table_name` SET column_2=?',
          // [Math.random() * 10000]
            'asdasd'
        ).then(function (response) {
            // resolve()의 결과 값이 여기로 전달됨
            console.log('tableData: ', response); // $.get()의 reponse 값이 tableData에 전달됨
          });
        // tool_app.api('SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50').then(function (response) {
        //   // resolve()의 결과 값이 여기로 전달됨
        //   console.log('tableData: ', response); // $.get()의 reponse 값이 tableData에 전달됨
        //   response.data.results.forEach(function (element) {
        //     tool_app.lg('el:', element);
        //   })
        // });

        // this.$http({
        //   method: 'post', //you can set what request you want to be
        //   url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
        //   data: {
        //     "c": "console.log(\"asd\");",
        //     "query": "INSERT INTO `table_name` SET column_2=?",
        //     "params": [Math.random()*10000],
        //     "greeter": "asd",
        //   },
        //   headers: {
        //     "x-api-key": "FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM",
        //     "Content-Type": "application/json",
        //   }
        // })
        //         .then(function (response) {
        //           // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
        //           console.log('response:',response);
        //         });

        // Auth.currentSession()
        //   .then(data => {
        //     console.log(data)
        //
        //     http({
        //       method: 'post', // you can set what request you want to be
        //       url: 'https://b2mmnijy50.execute-api.ap-northeast-2.amazonaws.com/default/wework-lambda-debug-20190618',
        //       data: {
        //         'c': 'console.log("asd");',
        //         'query': 'SELECT * FROM `table_name` ORDER BY column_1 DESC LIMIT 50',
        //         'params': [Math.random() * 10000],
        //         'greeter': 'asd',
        //       },
        //       headers: {
        //         'x-api-key': 'FzNOh8Zswn8vt0gJ8Rm8g6daOifpYrlz1EdrSYVM',
        //         'Content-Type': 'application/json',
        //         'Authorization': data.idToken.jwtToken,
        //       }
        //     })
        //       .then(function (response) {
        //         // response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
        //         console.log('response:', response)
        //         response.data.results.forEach(function (element) {
        //           console.log(element)
        //         })
        //       })
        //   })
        //   .catch(err => console.log(err))
      },
      testinsert () {
        console.log('testinsert');
        tool_app.api('INSERT INTO `table_name` SET column_2=?',
          [Math.random() * 10000]).then(function (response) {
          // resolve()의 결과 값이 여기로 전달됨
          console.log('tableData: ', response);
        });
      },
      signin () {
        console.log('signin')

        // this.auth.getSession();
        Auth.signIn('test1233', 'test1233')
          .then(data => {
            console.log(data)
          })
          .catch(err => console.log(err))
      },
      signout () {
        // this.auth.getSession();

        console.log('signOut')
        Auth.signOut()
          .then(data => {
            console.log(data)
          })
          .catch(err => console.log(err))
      },
      signup () {
        var params = {
          ClientId: 'STRING_VALUE', /* required */
          Password: 'STRING_VALUE', /* required */
          Username: 'STRING_VALUE', /* required */
          AnalyticsMetadata: {
            AnalyticsEndpointId: 'STRING_VALUE'
          },
          SecretHash: 'STRING_VALUE',
          UserAttributes: [
            {
              Name: 'STRING_VALUE', /* required */
              Value: 'STRING_VALUE'
            },
            /* more items */
          ],
          UserContextData: {
            EncodedData: 'STRING_VALUE'
          },
          ValidationData: [
            {
              Name: 'STRING_VALUE', /* required */
              Value: 'STRING_VALUE'
            },
            /* more items */
          ]
        }
        this.auth.signUp(params, function (err, data) {
          if (err) {
            console.log(err, err.stack)
          }// an error occurred
          else {
            console.log(data)
          } // successful response
        })
      },
    }
  }
</script>
